export default {
  numero: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  descricao: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  gerenteId: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  regionalId: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  funcionariosId: {
    value: [],
    options: [],
    required: false,
    state: null
  },
  codigoOmniChannel: {
    value: '',
    maxlength: '2',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/pa/components/add/pa-form.js